import type { ReactElement } from 'react';

import { ModelBoundariesCard } from '../dashboard/ModelBoundariesCard.js';
import { ModelGeoBlocksCard } from '../dashboard/ModelGeoBlocksCard.js';
import { SettingsStack } from './SettingsStack.js';

export function SettingsSafetyPage(): ReactElement {
  return (
    <SettingsStack titleKey="common.studio.settings.safetyTitle" hintKey="common.studio.settings.safetyHint">
      <ModelBoundariesCard />
      <ModelGeoBlocksCard />
    </SettingsStack>
  );
}
